"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentWidth = void 0;
var react_1 = require("react");
var getWidth = function () { return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; };
function useCurrentWidth() {
    var _a = react_1.useState(getWidth()), width = _a[0], setWidth = _a[1];
    react_1.useEffect(function () {
        var timeoutId;
        var resizeListener = function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () { return setWidth(getWidth()); }, 150);
        };
        window.addEventListener('resize', resizeListener);
        return function () {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    return width;
}
exports.useCurrentWidth = useCurrentWidth;
